import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "propertySumme",
    standalone: false
})
export class PropertySummePipe implements PipeTransform {
  transform(items: any[], property: string): number {
    if (!items?.length) return 0;

    return items.reduce((summe, item) => summe + (item[property] ?? 0), 0);
  }
}
